
import { Client } from '@stomp/stompjs';

class StompClient {
  client = null
  constructor() {
    this.client = new Client({
      connectHeaders: {
        host: process.env.REACT_APP_RABBIT_HOST,
        login: process.env.REACT_APP_RABBIT_USER_NAME,
        passcode: process.env.REACT_APP_RABBIT_PASSWORD,
      },
      webSocketFactory: () => new WebSocket(process.env.REACT_APP_RABBIT_SOCKET),
      debug: function (str) {
        console.log(str);
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    // Add error handling functions
    this.client.onWebSocketClose = this.onWebSocketClose;
    this.client.onWebSocketError = this.onWebSocketError;
    this.client.onUnhandledMessage = this.onUnhandledMessage;
    this.client.onUnhandledFrame = this.onUnhandledFrame;

  }

  connect(onConnect: { (): void; (): void; (): void; }, onError: { (error: any): void; (error: any): void; (error: any): void; }) {
    this.client.onConnect = onConnect;
    this.client.onStompError = onError;
    this.client.activate();
  }

  disconnect() {
    this.client.deactivate();
  }

  send(destination: string, body: string) {
    this.client.publish({ destination, body });
  }

  subscribe(
    destination: string,
    callback: { (message: any): void; (message: any): void; (message: any): void; },
    customHeaders?: { [key: string]: string }
  ) {
    const defaultHeaders = {
      'durable': 'true', // để queue không lưu lại sau restart
      'auto-delete': 'false', // để queue tự xóa khi client ngắt kết nối
      'x-expires': '600000', // Xóa queue sau khoảng thời gian không sử dụng (tính từ lần cuối cùng)
    };

    const headers = { ...defaultHeaders, ...customHeaders };
    return this.client.subscribe(destination, callback, headers);
  }

  // Error handling functions
  onWebSocketClose(evt: any) {
    console.error('WebSocket closed: ', evt);
  }

  onWebSocketError(evt: any) {
    console.error('WebSocket error: ', evt);
  }

  onUnhandledMessage(message: any) {
    console.warn('Unhandled message: ', message);
  }

  onUnhandledFrame(frame: any) {
    console.warn('Unhandled frame: ', frame);
  }

}

const stompClient = new StompClient();
export default stompClient;
